import { Link } from "gatsby";
import React from "react";
import Section from "./Section";

const Concert = () => {
  return (
    <Section bgColor="bg-navy" textColor="text-navy" comment="enjoy music!">
      <h1
        id="concert"
        className="relative text-4xl text-gold font-marvin mt-12 mb-16 leading-tight z-10"
      >
        Euph
        <span className="font-caprizant text-6xl pl-2 pr-1 text-white">&</span>
        Tuba
        <br />
        Carnival
      </h1>
      <span className="absolute -top-7 left-32 text-[#244BBE] font-caprizant leading-normal text-[12rem] mr-1 z-0">
        4<span className="text-[8rem] font-caprizant">th</span>
      </span>
      <a
        href="https://forms.gle/E5Be3cRTJrv99Dkq7"
        className="reservation block w-48 mb-16 text-center"
      >
        来場予約はコチラ！
      </a>
      <h2 className="text-white text-2xl font-bold mb-3">日程</h2>
      <p className="text-white mb-8">2022年10月2日 (日曜日)</p>
      <h2 className="text-white text-2xl font-bold mb-3">会場</h2>
      <p className="text-white mb-8">池田市民文化会館アゼリアホール</p>
      <h2 className="text-white text-2xl font-bold mb-3">曲目</h2>
      <h3 className="text-white text-xl font-bold mt-6 mb-3">
        第<span className="font-caprizant mx-2 text-3xl text-gold">1</span>部
      </h3>
      <ul className="mb-4">
        <li className="text-white">⾳楽祭のプレリュード</li>
        <li className="text-white">The Seventh Night of July (たなばた)</li>
        <li className="text-white -ml-2">「アイーダ」より凱旋⾏進曲</li>
      </ul>
      <h3 className="text-white text-xl font-bold mb-3">
        第<span className="font-caprizant mx-1 text-3xl text-gold">2</span>部
      </h3>
      <ul className="mb-4">
        <li className="text-white">アンサンブルステージ</li>
      </ul>

      <h3 className="text-white text-xl font-bold mb-3">
        第<span className="font-caprizant mx-1 text-3xl text-gold">3</span>部
      </h3>
      <ul className="mb-4">
        <li className="text-white">エル・クンバンチェロ</li>
        <li className="text-white">アラジン</li>
        <li className="text-white">ミュージカル「レ・ミゼラブル」より</li>
      </ul>
      <p className="text-gold font-bold my-12 border-gold w-32 text-center border-2 px-6 py-2">
        入場無料
      </p>
      <Link
        href="/news/concert"
        className="text-white underline drop-shadow-md"
      >
        演奏会詳細を見る
      </Link>
    </Section>
  );
};

export default Concert;
